import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_430: DocMigration = {
  maxSchemaVersion: "0.0.430",
  description: "Empty migration for the new array buffer view typing system",
  apply(json: any) {
    // This migration is empty, but it is necessary to ensure that the schema version is updated
    // and to avoid having a gap in the migration steps.

    return json;
  },
};

export default migration_0_0_430;
